import { render, staticRenderFns } from "./IBstatus.vue?vue&type=template&id=9d376a64&"
import script from "./IBstatus.vue?vue&type=script&lang=js&"
export * from "./IBstatus.vue?vue&type=script&lang=js&"
import style0 from "./IBstatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports